import { useSearchAndShuffleContext } from './context';

type UseActionsHelperReturnType = {
  setSwipeAction: (
    deckIndex: number,
    actionType: 'left' | 'right' | 'super'
  ) => void;
  removeCardFromDeck: (deckIndex: number, cardIndex: number) => void;
};

export const useActionsHelper = (): UseActionsHelperReturnType => {
  const { decks, setActionMap, setDecks } = useSearchAndShuffleContext();

  const setSwipeAction = (
    deckIndex: number,
    actionType: 'left' | 'right' | 'super'
  ): void => {
    const cardId = decks?.[deckIndex]?.cards?.[0]?.data?.id;
    if (!cardId) {
      return;
    }
    setActionMap((prevActionMap) => ({
      ...prevActionMap,
      [cardId]: actionType,
    }));
  };

  const removeCardFromDeck = (deckIndex: number, cardIndex: number): void => {
    setDecks((prevDecks) => {
      return prevDecks.map((deck, i) => {
        if (i !== deckIndex) return deck;

        return {
          ...deck,
          cards: deck.cards.filter((_, idx) => idx !== cardIndex),
        };
      });
    });
  };

  return {
    setSwipeAction,
    removeCardFromDeck,
  };
};
